import React, {useState} from "react";
import {connect} from "react-redux";
import {CopyToClipboard} from "react-copy-to-clipboard";
import notifyUser from "../../methods/notifyUser";
import {trackGoal} from "../../methods/trackGoal";
import {checkPermission, UserPermission} from "../../methods/permissionByRole";
import {useMediaQuery} from "@mui/material";
import ReferralsView from "./ReferralsView";
import {loadSelf} from "../../methods/loadSelf";
import {mobileMaxWidthMediaQuery} from "../../methods/utils";
import "pages/Styles/ProfileV2.sass";

let MyPromoCodeView: any = function MyPromoCodeView(props: any) {
    const {fullScreen} = props
    const mobile = useMediaQuery(mobileMaxWidthMediaQuery)
    const [referralsPopup, setReferralsPopup] = useState(false);

    const partnerInfo = props.$store.userSession?.partner_info
    const isPartnerProgram = !!partnerInfo
    const partnerRewardPercent =
        partnerInfo != null && typeof partnerInfo.percentage === "number"
            ? partnerInfo.percentage
            : 20

    const titleAlign = fullScreen ? "center" : "left"

    return <>
        {isPartnerProgram ? (
            <>
                <div className="profile-section-title" style={{ textAlign: titleAlign }}>
                    Партнёрский промокод
                </div>
                <div className="profile-section-subtitle" style={{ textAlign: "left" }}>
                    <p className="profile-promo-partner-reward">
                        Вознаграждение: {partnerRewardPercent}% с каждой транзакции привлечённых клиентов
                    </p>
                    <p className="profile-promo-partner-details">
                        Поделитесь персональной ссылкой или промокодом. После регистрации и первой покупки клиент
                        появится в «Мои клиенты», а вы будете получать вознаграждение за его покупки. Отчёты и выплаты
                        — в разделе «Партнёрская программа».
                    </p>
                </div>
            </>
        ) : (
            <>
                <div className="profile-section-title" style={{ textAlign: titleAlign }}>
                    Ваш промо-код
                </div>
                <div className="profile-section-subtitle" style={{ textAlign: "left" }}>
                    Поделитесь промо-кодом с коллегой — он получит +30% к пакету, а вы — 20% от его покупки.
                    <br/><br/>
                    За первую покупку друга — 50% кэшбек на карту! 🔥
                    <span className="profile-promo-footnote">
                        Промо-коды действуют только на первую покупку
                    </span>
                </div>
            </>
        )}
        <div
            className={
                fullScreen
                    ? "profile-promo-code-row profile-promo-code-row--full-screen"
                    : "profile-promo-code-row"
            }
        >
            <div className="profile-section-label">
                {props.$store.userSession?.promo_code?.code_name ?? ''}
            </div>
            <CopyToClipboard
                onCopy={() => {
                    notifyUser(props, 'Ссылка на регистрацию с промо-кодом скопирована', 'Теперь можете поделиться ей')
                }}
                text={`https://desktop.doki.online/register?promoCode=${props.$store.userSession?.promo_code?.code_name ?? ''}`}
            >
                <button
                    type="button"
                    className="new ui-kit-v2-button action-button primary inline"
                    onClick={() => {
                        if (fullScreen) {
                            trackGoal('user_story_referral_share_promo')
                        }
                        trackGoal('share_link')
                        if ('share' in navigator && mobile) {
                            navigator.share({
                                title: 'Ссылка на регистраци в ОкиДоки с промо-кодом',
                                url: `https://desktop.doki.online/register?promoCode=${props.$store.userSession?.promo_code?.code_name ?? ''}`
                            })
                        }}
                    }
                >
                    <span className="button-text">Поделиться ссылкой</span>
                </button>
            </CopyToClipboard>
        </div>
        {
            checkPermission(props, UserPermission.OWNER) && !fullScreen && !props.$store.userSession?.partner_info &&
            <>
                <hr className="profile-section-divider"/>

                <div className="profile-section-row">
                    <button
                        className="new action-button secondary"
                        onClick={() => {
                            trackGoal('show_referral_list')
                            setReferralsPopup(true)
                        }}
                    >
                        <span className="button-text">Посмотреть приведенных клиентов</span>
                    </button>
                </div>
            </>
        }

        {
            referralsPopup &&
            <ReferralsView
                close={() => {setReferralsPopup(false)}}
                onCollectBonus={loadSelf}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        }
    </>
}

MyPromoCodeView = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(MyPromoCodeView)

export default MyPromoCodeView